import { Link, useParams, Navigate } from "react-router-dom";
import { ArrowLeft, LifeBuoy } from "lucide-react";
import { HELP_ARTICLES } from "@/lib/helpArticles";

function Article({ a }) {
  return (
    <article data-testid={`help-article-${a.slug}`}>
      <Link to="/app/help" className="inline-flex items-center gap-1.5 text-sm text-sky-400 hover:underline mb-6" data-testid="help-back"><ArrowLeft className="h-4 w-4" />Help center</Link>
      <h1 className="font-display text-3xl sm:text-4xl font-semibold tracking-tight">{a.title}</h1>
      <p className="text-neutral-400 mt-3">{a.summary}</p>
      <div className="mt-8 space-y-4 text-neutral-200 leading-relaxed">{a.body.map((p) => <p key={p}>{p}</p>)}</div>
    </article>
  );
}

export default function HelpPage() {
  const { slug } = useParams();
  const article = slug && HELP_ARTICLES.find((a) => a.slug === slug);
  if (slug && !article) return <Navigate to="/app/help" replace />;
  return (
    <div className="flex-1 overflow-y-auto scroll-thin">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-8 sm:py-10" data-testid="help-page">
        {article ? <Article a={article} /> : (
          <>
            <h1 className="font-display text-4xl sm:text-5xl font-semibold tracking-tight flex items-center gap-3"><LifeBuoy className="h-8 w-8 text-sky-300" />Help center</h1>
            <p className="text-neutral-400 mt-3">Short guides to how BrynAI works.</p>
            <ul className="mt-8 space-y-2">
              {HELP_ARTICLES.map((a) => (
                <li key={a.slug}>
                  <Link to={`/app/help/${a.slug}`} data-testid={`help-link-${a.slug}`} className="block soft-card px-5 py-4 hover:border-sky-400/30 transition-colors">
                    <span className="block font-medium text-neutral-100">{a.title}</span>
                    <span className="block text-sm text-neutral-500 mt-0.5">{a.summary}</span>
                  </Link>
                </li>
              ))}
            </ul>
          </>
        )}
      </div>
    </div>
  );
}
